import React, {
  ReactElement,
  useEffect,
  useRef,
  useState,
  useCallback,
  useReducer,
} from 'react';
import { SchemaWithClient } from '../../types/SchemaWithClient';
import { Entity } from '../../types/entities/Entity';
import {
  Button,
  IconButton,
  Stack,
  Table,
  TableContainer,
  Typography,
} from '@mui/material';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { MoreOptions } from '../Table/assets/MoreOptions';
import { toaster } from '../../services/toaster';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import { SlidingPaneEdit } from '../Page/SlidingPaneEdit';
import Tooltip from '@mui/material/Tooltip';
import AddIcon from '@mui/icons-material/Add';
import api from '../../services/api';
import { SlidingPaneAddNew } from '../Page/SlidingPaneAddNew';
import CloudDoneRoundedIcon from '@mui/icons-material/CloudDoneRounded';
import Fade from '@mui/material/Fade';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import { serviceReservationAddNew } from '../../schema/serviceReservationAddNew';
import { serviceReservationEdit } from '../../schema/serviceReservationEdit';
import Avatar from "@mui/material/Avatar";
import * as Icons from '@mui/icons-material';

type Props<T extends Entity> = {
  schema: SchemaWithClient<T>;
};

const reducer = (state: any, action: any) => {
  switch (action.type) {
    case 'SET_INPUT':
      const newCurrent: any = [...state.current];

      return {
        ...state,
        current: newCurrent,
        send: true,
      };
    case 'SET_HISTORY':
      return {
        ...state,
        current: action.payload,
        send: false,
      };
    default:
      return state;
  }
};

export const ServiceReservation = ({
  schema,
  values,
  fullWidth,
}: {
  schema: any;
  values: any;
  fullWidth: boolean;
}): ReactElement => {
  const [openConfirmDialog, setOpenConfirmDialog] = useState<any>(false);
  const [state, dispatch] = useReducer(reducer, {
    current: [],
    send: false,
  });
  const [openedSlidingPane, setOpenedSlidingPane] = useState<any>(false);
  const [loading, setLoading] = useState<any>(false);
  const [query, setQuery] = useState<'idle' | 'progress' | 'success'>(
    'idle'
  );
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  const [currentAddNewPaneEntity, setCurrentAddNewPaneEntity] = useState<
    any
  >(false);

  const fetchMainData = useCallback(() => {
    setLoading(true);
    const searchParams = new URLSearchParams({});

    api
      .get(`/service-reservations/${values.id}`, searchParams)
      .then((res: any) => {
        setLoading(false);
        dispatch({
          type: 'SET_HISTORY',
          payload: res,
        });
      });
  }, []);

  useEffect(() => {
    console.log('fetchMainData');
    fetchMainData();
  }, []);

  return (
    <>
      <TableContainer component={Paper}>
        <Table
          aria-label="simple table"
          size="small"
          sx={{
            opacity: loading ? 0.8 : 1,
            pointerEvents: loading ? 'none' : 'auto',
          }}
        >
          <TableHead
            sx={{
              '& .MuiTableCell-root': {
                color: 'inherit',
                border: 'none',
              },
              '& .MuiTableRow-root .MuiTableCell-root.MuiTableCell-head': {
                border: 'none',
                fontSize: '14px',
                p: '16px 6px',
              },
              background: '#256861',
              color: '#fff',
            }}
          >
            <TableRow
              sx={{
                '& .MuiTableCell-root': {
                  overflowWrap: 'anywhere',
                },
              }}
            >
              <TableCell></TableCell>
              <TableCell
                sx={{
                  minWidth: '120px',
                }}
              >
                Date
              </TableCell>

              <TableCell
                sx={{
                  minWidth: '120px',
                }}
              >
                Start Time
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '120px',
                }}
              >
                Service Group
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '140px',
                }}
              >
                Service Provider
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '100px',
                }}
              >
                Service
              </TableCell>
              <TableCell
                sx={{
                  textAlign: 'center',
                  minWidth: '120px',
                }}
              >
                Status
              </TableCell>

              <TableCell
                sx={{
                  textAlign: 'center',
                  minWidth: '100px',
                }}
              >
                Group Size
              </TableCell>
            </TableRow>
          </TableHead>
          {state.current.map((row: any) => {

            const IconComponent = Icons[row.service_reservation_status?.icon.name as keyof typeof Icons];
            
            return (
              <TableRow
                sx={{
                  '& .MuiTableRow-root .MuiTableCell-root': {
                    p: '6px',
                  },
                  background:
                    openConfirmDialog?.id === row?.id ? '#eab6b6' : '#fff',
                  textDecoration: row?.service_reservation_type_id === 4 ? 'line-through' : ''
                }}
              >
                <TableCell>
                  <MoreOptions
                    clickOnEdit={() => {
                      setOpenedSlidingPane(row);
                    }}
                    clickOnDelete={() => {
                      setOpenConfirmDialog(row);
                    }}
                  />
                </TableCell>
                <TableCell>{row?.date}</TableCell>
                <TableCell>{row?.time}</TableCell>
                <TableCell>{row?.service_package?.name}</TableCell>
                <TableCell>{row?.show_service_provider}</TableCell>
                <TableCell>{row?.show_service}</TableCell>
                <TableCell align="center">
                  {row.service_reservation_status?.icon ? (
                    <Tooltip
                      title={row.service_reservation_status?.name}
                      slotProps={{
                        popper: {
                          modifiers: [
                            {
                              name: 'offset',
                              options: {
                                offset: [0, -14],
                              },
                            },
                          ],
                        },
                      }}
                    >
                      <Stack alignItems={'center'}>
                        <Avatar
                          sx={{
                            background: `${
                              row.service_reservation_status?.color?.color
                                ? row.service_reservation_status?.color?.color
                                : '#FFFFFF00'
                            }`,
                            width: 20,
                            height: 20,
                            '& .MuiSvgIcon-root':{
                              fontSize: '20px'
                            }
                          }}
                        >
                          {row.service_reservation_status?.icon && (
                            <>{IconComponent ? <IconComponent /> : null}</>
                          )}
                        </Avatar>
                      </Stack>
                    </Tooltip>
                  ) : (
                    <>{row.service_reservation_status?.name}</>
                  )}
                </TableCell>
                <TableCell align="center">{row.size}</TableCell>
              </TableRow>
            );
          })}
        </Table>
      </TableContainer>

      <Stack
        direction={'row'}
        alignItems={'center'}
        sx={{
          width: '100%',
        }}
        justifyContent={'space-between'}
      >
        <Stack direction={'row'}>
          <Tooltip
            title={`Add new`}
            slotProps={{
              popper: {
                modifiers: [
                  {
                    name: 'offset',
                    options: {
                      offset: [0, -14],
                    },
                  },
                ],
              },
            }}
          >
            <IconButton
              color={'primary'}
              onClick={() => {
                setCurrentAddNewPaneEntity({
                  row: {
                    id: 'new',
                    group: {
                      id: values?.id,
                      name: values?.name,
                    },
                  },
                });
              }}
            >
              <AddIcon />
            </IconButton>
          </Tooltip>
        </Stack>
        <Stack>
          {query === 'success' ? (
            <Stack direction={'row'} alignItems={'center'}>
              <CloudDoneRoundedIcon color={'disabled'} />
              <Typography variant={'caption'} marginLeft={'5px'} color={'gray'}>
                successfully saved
              </Typography>
            </Stack>
          ) : (
            <Fade
              in={query === 'progress'}
              style={{
                transitionDelay: query === 'progress' ? '800ms' : '0ms',
              }}
              unmountOnExit
            >
              <CircularProgress size={20} />
            </Fade>
          )}
        </Stack>
      </Stack>

      {currentAddNewPaneEntity && (
        <>
          <SlidingPaneAddNew
            schema={serviceReservationAddNew}
            id={'new'}
            hasSlidingPane={false}
            onSubmit={(result: any) => {
              fetchMainData();
              setCurrentAddNewPaneEntity(false);
              setQuery('progress');
              timerRef.current = setTimeout(() => {
                setQuery('success');
              }, 2000);
            }}
            propertiesFromTable={
              {
                group: values?.group,
                activity_reservation: values?.activity_reservation,
              }
            }
            row={{
              group: values?.group,
              activity_reservation: values?.activity_reservation,
            }}
            onClose={(value) => {
              setCurrentAddNewPaneEntity(false);
            }}
          />
        </>
      )}

      {openConfirmDialog && (
        <Dialog
          open={openConfirmDialog}
          onClose={() => {
            setOpenConfirmDialog(false);
          }}
        >
          <DialogTitle>{'Are you sure you want to delete it?'}</DialogTitle>
          <DialogActions>
            <Button
              onClick={() => {
                setOpenConfirmDialog(false);
              }}
            >
              Cancel
            </Button>
            <Button
              variant={'contained'}
              color={'error'}
              onClick={() => {
                api
                  .delete(`/service-reservations/${openConfirmDialog?.id}`)
                  .then((res: any) => {
                    toaster.show({
                      intent: 'success',
                      message: `Successfully deleted ${schema.name}: ${
                        openConfirmDialog?.name
                          ? openConfirmDialog?.name
                          : openConfirmDialog?.id
                      }`,
                    });
                    setOpenConfirmDialog(false);
                    setQuery('progress');
                    fetchMainData();
                    timerRef.current = setTimeout(() => {
                      setQuery('success');
                    }, 2000);
                  })
                  .catch((e: any) => {
                    toaster.show({
                      icon: 'error',
                      message: `Error: Unable to delete ${schema.name}: ${
                        openConfirmDialog?.name
                          ? openConfirmDialog?.name
                          : openConfirmDialog?.id
                      }`,
                      intent: 'danger',
                    });
                  });
              }}
              autoFocus
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {openedSlidingPane && (
        <SlidingPaneEdit
          schema={serviceReservationEdit}
          id={openedSlidingPane?.id}
          onSubmit={() => {
            setOpenedSlidingPane(false);
            fetchMainData();
            setQuery('progress');
            timerRef.current = setTimeout(() => {
              setQuery('success');
            }, 2000);
          }}
          propertiesFromTable={openedSlidingPane ? openedSlidingPane : {}}
          onClose={(value) => {
            setOpenedSlidingPane(false);
          }}
        />
      )}
    </>
  );
};
